import router from './router'
import store from './store'
import Vue from 'vue'
import {
	Message
} from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {
	getLanguageConfig,
} from '@/common/api/public.js'

NProgress.configure({
	showSpinner: false
}) // NProgress Configuration

let url = ''
let getPath = (arr) => {
	if (arr[0].children) {
		getPath(arr[0].children)
	} else {
		url = arr[0].meta.url
	}
}

// 设置系统配置

let getSysConfig = async () => {
	const { data } = await getLanguageConfig()
	let result = JSON.parse(data)
	Vue.prototype.$sysParams = result
	document.title = result.sys_name
	let getCreate = function (url) {
		var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
		link.type = 'image/x-icon';
		link.rel = 'shortcut icon';
		link.href = url
		document.getElementsByTagName('head')[0].appendChild(link);
	}
	if (result.sys_logo && result.sys_logo.length) {
		getCreate(result.sys_logo[0].download_url || result.sys_logo[0].link_url)
	}
	// console.log(data,'系统配置系统配置')
}

const whiteList = ['/login', '/auth-redirect', '/business', '/empowerment', '/data-manage', '/reporting-management', '/data-management'] // no redirect whitelist
router.beforeEach(async (to, from, next) => {
	// start progress bar
	NProgress.start()
	// determine whether the user has logged in
	const hasToken = window.localStorage.getItem('access_token')
	if (hasToken) {
		if (to.path === '/empty') {
			next()
			NProgress.done()
		} else if (to.path === '/login') {
			// getPath(store.getters.addRoutes)
			if (to.fullPath.indexOf("routerName") !== -1) {
				for (let key in to.query) {
					if (key === "routerName") {
						window.location.href = `http://122.51.76.10:8816/#/?routerName=${to.query[key]}&token=${hasToken}`;
					}
				}
			} else {
				next('/business')
			}
			NProgress.done()
		} else {
			const hasRoles = store.getters.role
			if (hasRoles) {
				if (to.path === '/') {
					getPath(store.getters.addRoutes)
					next(url)
				} else {
					let flag = false
					let getUrl = (arr) => {
						arr.forEach((item, index) => {
							if (item.meta && item.meta.url && to.path === item.meta.url ||
								whiteList.includes(to.path)) {
								flag = true
							}
							if (item.children && item.children.length) {
								getUrl(item.children)
							}
						})
					}
					getUrl(store.getters.addRoutes)
					next()
					if (flag) { } else {
						// next('/404')
					}
				}
				NProgress.done()
			} else {
				try {
					const data = await store.dispatch('user/getInfo')
					getSysConfig()
					const accessRoutes = await store.dispatch('permission/generateRoutes', data.type)
					accessRoutes.forEach(routeConfig => {
						router.addRoute(routeConfig);
					})
					if (to.path === '/') {
						getPath(accessRoutes)
						next(url)
					} else {
						let flag = false
						let getUrl = (arr) => {
							arr.forEach((item, index) => {
								if (item.meta && item.meta.url && to.path === item.meta.url ||
									whiteList.includes(to.path)) {
									flag = true
								}
								if (item.children && item.children.length) {
									getUrl(item.children)
								}
							})
						}
						getUrl(accessRoutes)
						if (flag) {
							next({
								...to,
								replace: true
							})
						} else if (to.path === '/not-permission') {
							next()
						} else {
							next('/404')
						}

					}
				} catch (error) {
					Message.error(error || 'Has Error')
					next(`/login?redirect=${to.path}`)
					NProgress.done()
				}
			}
		}
	} else {
		/* has no token*/

		if (whiteList.indexOf(to.path) !== -1) {
			// in the free login whitelist, go directly
			next()
		} else {
			// other pages that do not have permission to access are redirected to the login page.
			next(`/login?redirect=${to.path}`)
			NProgress.done()
		}
	}
})

router.afterEach(() => {
	// finish progress bar
	NProgress.done()
})